<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    style="border-top: 1px solid #ebeef5"
  >
    <van-tabbar-item
      to="/service"
      name="service"
      icon="apps-o"
      @click="handleNavigate('/service')"
    >
      <span>业务</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Footer",
  components: {},
  props: {
    show: {
      // 显示与否
      type: Boolean,
      default: true,
    },
    value: {
      // 通过v-model绑定current值
      type: String,
      default: "dashboard",
    },
    activeColor: {
      // 激活时的演示，包括字体图标，提示文字等的演示
      type: String,
      default: "#E98F36",
    },
    inactiveColor: {
      // 未激活时的颜色
      type: String,
      default: "#c8c9cc",
    },
    beforeSwitch: {
      // 切换前的回调
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      active: this.value,
    };
  },
  computed: {
    ...mapGetters({
      personType: "user/personType",
    }),
  },
  created() {
    this.active = this.$route.path.replace(/\//g, "|").split("|")[1];
  },
  methods: {
    handleNavigate(path) {
      this.$router.push({
        path,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.van-tabbar {
  height: 8vh;
  font-size: 2vw;
}
</style>
